export const normalizeEntityBeforeSaving = (creditMemo) => {
  const entity = JSON.parse(JSON.stringify(creditMemo));
  return entity;
};
